var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplayDp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 6.4,
    fill: "#AAAEB6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3956_9448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5008 16.8C18.4176 16.8 20.1608 17.3552 21.4432 18.1376C22.0832 18.528 22.6304 18.9888 23.0256 19.4896C23.4144 19.9816 23.7008 20.5704 23.7008 21.2C23.7008 21.876 23.372 22.4088 22.8984 22.7888C22.4504 23.1488 21.8592 23.3872 21.2312 23.5536C19.9688 23.8872 18.284 24 16.5008 24C14.7176 24 13.0328 23.888 11.7704 23.5536C11.1424 23.3872 10.5512 23.1488 10.1032 22.7888C9.62878 22.408 9.30078 21.876 9.30078 21.2C9.30078 20.5704 9.58718 19.9816 9.97598 19.4888C10.3712 18.9888 10.9176 18.5288 11.5584 18.1368C12.8408 17.356 14.5848 16.8 16.5008 16.8ZM16.5008 8C17.5616 8 18.5791 8.42143 19.3292 9.17157C20.0794 9.92172 20.5008 10.9391 20.5008 12C20.5008 13.0609 20.0794 14.0783 19.3292 14.8284C18.5791 15.5786 17.5616 16 16.5008 16C15.4399 16 14.4225 15.5786 13.6724 14.8284C12.9222 14.0783 12.5008 13.0609 12.5008 12C12.5008 10.9391 12.9222 9.92172 13.6724 9.17157C14.4225 8.42143 15.4399 8 16.5008 8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3956_9448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(6.90039 6.39844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayDp);
export default __webpack_public_path__ + "static/media/display-dp.5852e97247ebd80201634cb49347646d.svg";
export { ForwardRef as ReactComponent };